module.exports = __webpack_public_path__ + "img/chris_g_23.6717a777.jpg";